import React from 'react'
import { isArray, toString, isString, isPlainObject } from 'lodash-es'
import { IconMaps } from '@ow/icons'

const IconedTextRender = function ({ stext }) {
  const { text, color, icon } = stext
  return (
    <div
      className="flex items-center gap-1"
      style={{
        color,
      }}
    >
      <IconMaps type={icon} width={13} height={13} fill="currentColor" />
      {text}
    </div>
  )
}

const PlainTextRender = function ({ stext }) {
  const isDom = React.isValidElement(stext)
  return stext.onClick ? (
    <div
      className="cursor-pointer w-full"
      onClick={stext.onClick}
      title={stext.text}
    >
      {isDom ? stext : stext.text}
    </div>
  ) : (
    <span title={stext.text}>{isDom ? stext : stext.text}</span>
  )
}

const TextRender = function ({ value, onClick }) {
  const stext = {
    onClick,
  }

  if (isString(value)) {
    stext.text = value
  } else if (isPlainObject(value)) {
    Object.assign(stext, value)
  } else {
    stext.text = toString(value)
  }

  return stext.icon ? (
    <IconedTextRender stext={stext} />
  ) : (
    <PlainTextRender stext={stext} />
  )
}

console.log('renders')
const Text = function ({ value, onClick }) {
  if (isArray(value)) {
    return (
      <>
        {value.map((item) => {
          return (
            <div
              key={item}
              style={{
                background: 'var(--ow-color-neutral-100)',
                borderRadius: '4px',
                padding: '2px 8px',
              }}
            >
              <TextRender value={item} onClick={onClick} />
            </div>
          )
        })}
      </>
    )
  }

  return <TextRender value={value} onClick={onClick} />
}

export default Text
